<template>
  <div>
    <PageTable
      :loading="loading"
      :tableData="tableData"
      :tablePage="page"
      :multiple="multiple"
      @reload="reload"
      @change="(e) => $emit('change', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>
<script>
import PageHeader from './header.vue'
import PageTable from './table.vue'
import BaseTable from '@/mixins/base-table'
import { request } from '@/api/service'
export default {
  mixins: [BaseTable],
  components: { PageTable, PageHeader },
  props: {
    multiple: { type: Boolean, default: false },
    evgSpuCode: { type: String, default: '' },
  },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      request({
        url: '/ecom/ecom/evg/spu/options',
        method: 'POST',
        data: { ...form, ...this.page, evgSpuCode: this.evgSpuCode },
      })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
